import * as z from "zod/v4";

export const getChargebacksGorgiasAuthUrl = {
  name: "getChargebacksGorgiasAuthUrl" as const,
  input: z.object({ account: z.string().min(1) }),
  output: z.object({ authorizationUrl: z.string() }),
};
